// NeuroID session identity shared by every NeuroID site script we load
// (see Step1/NeuroId): ours (Koalafi), AFF's and Uown's. All of them read the
// same global `nid` queue, so one `identify` call tags the session for all
// providers. The identity is stored in redux as `koalafiNeuroId` and sent to
// the backend as `koalafi_neuro_id`, where it is forwarded to the providers
// (Uown: `neuroIdentity` in sendApplication).

export const generateNeuroIdentity = () => {
  if (window.crypto && typeof window.crypto.randomUUID === "function") {
    return window.crypto.randomUUID();
  }
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );
};

export const identifyNeuroId = (identity) => {
  if (!identity) return;

  try {
    if (window.nid) {
      window.nid("identify", String(identity));
      console.log("NeuroID session identified:", identity);
    }
  } catch (e) {
    console.log(`NID Err: ${e}`);
  }
};
